export default __webpack_public_path__ + "static/media/sr.8ac50456.svg";